import { ApiHelper } from './api.helper';
import { IPreInscriptionSummary } from '../types/pre-inscription-summary.type';
import { HttpUtils } from '../utils/http.utils';
import { IFilters, IRequestParams } from '../views/PreInscriptionsSummary/types';

export const fetchPreInscriptionsSummary = async (
  filters: IFilters,
): Promise<IPreInscriptionSummary[]> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('pre-inscriptions/summary')}?${queryParams}`;
  const response = await fetch(url, ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const downloadPreInscriptionsSummary = async (filters: IFilters): Promise<Blob> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('pre-inscriptions/summary/export')}?${queryParams}`;

  const response = await fetch(url, ApiHelper.makeOptions());
  const data = response.blob();

  if (!response.ok) {
    const responseData = await response.json();

    throw new Error(await responseData.message);
  }

  return data;
};
